import { render, staticRenderFns } from "./PainelUFMSDigital.vue?vue&type=template&id=141dc04c"
import script from "./PainelUFMSDigital.vue?vue&type=script&lang=js"
export * from "./PainelUFMSDigital.vue?vue&type=script&lang=js"
import style0 from "./PainelUFMSDigital.vue?vue&type=style&index=0&id=141dc04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports